import React, { Component } from "react";
import { Card } from "semantic-ui-react";
import CardHeaders from "../CardHeaders";

import Content from "./Content";
import Actions from "./Actions";

export default class THPCard extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { card, shadow, role, onUpdate } = this.props;

    return (
      <React.Fragment>
        <Card raised style={{ minWidth: 320, minHeight: 320 }}>
          <CardHeaders {...card} updatedOn={new Date(shadow.Timestamp)} />
          <Content {...shadow.data} titles={card.channels} />
          {role >= 75 ? (
            <Actions {...shadow} {...card} onUpdate={onUpdate} />
          ) : null}
        </Card>
      </React.Fragment>
    );
  }
}
